import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ViewEncapsulation, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, AfterViewInit, OnChanges } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms'
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { PaymentsService } from '../../services/payments.service'
import { Terminal } from '../../services/terminal.service'
import { UsersService } from '../../services/users.service'
import { MatButtonToggleChange } from '@angular/material/button-toggle'
import { ThisReceiver } from '@angular/compiler';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminalTransactionModalComponent } from '../terminal-transaction-modal/terminal-transaction-modal.component';

@Component({
	selector: 'app-pos-order-payments',
	templateUrl: './pos-order-payments.component.html',
	styleUrls: ['./pos-order-payments.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PosOrderPaymentsComponent implements OnInit, OnChanges {

	paymentForm: UntypedFormGroup;
	numberposition = 1;

	@Input() order_header: any = [];
	@Input() items: any = [];
	@Input() totals: any;
	@Input() pos: any = true;
	@Input() document_type: any = '30';
	@Input() payments: any = [];
	@Input() credits: any = [];

	//not being sent in the header. on time
	@Input() orderno: any;
	@Input() debtorno: any;
	@Input() branchcode: any;

	@Output() payments_added = new EventEmitter < any > ();
	@Output() payments_removed = new EventEmitter < any > ();
	@Output() credit_removed = new EventEmitter < any > ();

	@ViewChild('amountId') amountIdRef: ElementRef;

	paymentmethods: any = false
	bankaccounts: any = false;
	loadingcards = false;
	default_payment = '';
	change_due: any = false;

	hasprofile: any = false;
	profile_cards: any = false;
	payment_card: any = false;
	card_required: any = false;
	preselected_payment: any = false;
	color = 'blue'
	balance_due: any = 0.00;
	refund = new UntypedFormControl(false);
	numpad: number;
	keypadresult: any = false;
	creditAmt: any = false;
	appliedCredits: any = false;

	availableTerminals: Terminal[] = [];
	selectedTerminal: Terminal | null = null;
	terminalTransactionInProgress = false;
	hasTerminalConfigured = false;
	useOtherPaymentMethod = false;
	hasMultipleTerminals = false;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private globalSearchService: GlobalSearchService,
		private paymentsService: PaymentsService,
		private usersService: UsersService,
		private modalService: NgbModal
	) {
		this.color = this.globalSearchService.color;
	}

	ngOnInit(): void {
		this.globalSearchService.payment_methods.subscribe((results: any) => {
			if(results) {
				this.paymentmethods = results.filter((result: any) => result.pos_enabled === '1');
			} else {
				this.getPaymentMethods();
			}
		});

		this.globalSearchService.bankaccounts.subscribe((results: any) => {
			this.bankaccounts = results;
		});

		this.loadUserTerminals();
		this.resetPayForm();
		
	}

	loadUserTerminals() {
		const userVal = this.globalSearchService.user.getValue();
		const user = userVal?.user || userVal;
		if (!user?.userid) {
			this.hasTerminalConfigured = false;
			this.hasMultipleTerminals = false;
			this.availableTerminals = [];
			this.selectedTerminal = null;
			return;
		}
		this.usersService.getUserTerminals({ userid: user.userid }).subscribe(
			(rows: any) => {
				const list = Array.isArray(rows)
					? rows.map((t: any) => this.normalizeTerminal(t))
					: [];
				this.availableTerminals = list;
				this.hasTerminalConfigured = list.length > 0;
				this.hasMultipleTerminals = list.length > 1;
				this.selectedTerminal = this.getDefaultTerminal(list);
			},
			() => {
				this.hasTerminalConfigured = false;
				this.hasMultipleTerminals = false;
				this.availableTerminals = [];
				this.selectedTerminal = null;
			}
		);
	}

	private getDefaultTerminal(terminals: Terminal[]): Terminal | null {
		if (!terminals || !terminals.length) {
			return null;
		}
		const defaultTerminal = terminals.find((terminal: any) => {
			if (terminal?.is_default || terminal?.default) {
				return true;
			}
			const config = terminal?.connection_config;
			return !!(config && config.default);
		});
		return defaultTerminal || terminals[0];
	}

	private normalizeTerminal(t: any): Terminal {
		return {
			terminal_id: t.terminal_id,
			terminal_name: t.terminal_name || 'Unnamed Terminal',
			terminal_type: t.terminal_type,
			terminal_model: t.terminal_model || 'desk5000',
			terminal_serial: t.terminal_serial || '',
			connection_type: (t.connection_type || 'lan') as Terminal['connection_type'],
			is_active: true,
			is_available: true,
			connection_config: typeof t.connection_config === 'string' ? JSON.parse(t.connection_config || '{}') : t.connection_config,
			needs_registration: false
		};
	}


	getPaymentMethods() {
		this.globalSearchService.updatePaymentMethods();
		this.globalSearchService.payment_methods.subscribe((results: any) => {
			if(results) {
				this.paymentmethods = results.filter((result: any) => result.pos_enabled === '1');
			}
		});
	}


	isNegative() {
		return (this.financial(this.paymentForm.get('amount').value) < 0)
	}

	makeNegativePayment() {
		//Math.abs()
		const newvalue = -1 * this.financial(this.paymentForm.get('amount').value);
		if (newvalue > 1) {
			this.refund.setValue(false);
		} else {
			this.refund.setValue(true);
		}

		this.paymentForm.get('amount').setValue(newvalue)
	}

	addPaymentInput() {
		this.resetPayForm();
	}

	addPayment() {
		if (this.hasTerminalConfigured && !this.useOtherPaymentMethod) {
			this.handleTerminalPayment();
			return;
		}
		if (this.paymentForm.get('type').value == '') {
			this.globalSearchService.showNotification('Payment Type Required', 'danger', 'bottom', 'right');
			return false;
		}
		if (this.paymentForm.valid && this.financial(this.paymentForm.get('amount').value)) {
			const data = {
				payment: this.paymentForm.value,
				order: {
					orderno: (this.order_header.orderno) ? this.order_header.orderno : '1',
					debtorno: this.order_header.debtorno,
					branchcode: this.order_header.branchcode,
					document_type: this.document_type
				}
			};
			if (this.getBalance() != 0) {
				this.paymentsService.addPayment(data).subscribe((results: any[]) => {
					if(results['message'] && results['message'] != ''){
						this.globalSearchService.showNotification(results['message'], 'warning', 'bottom', 'right');
					}
					this.payments_added.emit(false);
					this.resetPayForm();

				});
			}
		}
	}

	handleTerminalPayment() {
		const terminalPaymentType = this.getTerminalPaymentType();
		if (!terminalPaymentType) {
			this.globalSearchService.showNotification('No valid payment method available for terminal payments', 'warning', 'bottom', 'right');
			return;
		}
		if (!this.selectedTerminal) {
			this.globalSearchService.showNotification('Please select a terminal', 'warning', 'bottom', 'right');
			return;
		}

		const balance = this.getBalance();
		if (balance <= 0) {
			const message = balance === 0
				? 'Order is already fully paid'
				: 'Order is overpaid. Cannot process terminal payment.';
			this.globalSearchService.showNotification(message, 'warning', 'bottom', 'right');
			return;
		}

		this.paymentForm.get('type').setValue(terminalPaymentType);
		this.card_required = false;
		this.openTerminalTransactionModal();
	}

	openTerminalTransactionModal() {
		const balance = this.getBalance();

		if (balance <= 0) {
			const message = balance === 0
				? 'Order is already fully paid'
				: 'Order is overpaid. Cannot process terminal payment.';
			this.globalSearchService.showNotification(message, 'warning', 'bottom', 'right');
			return;
		}
		const amountControl = this.paymentForm?.get('amount');
		const requestedAmount = this.financial(amountControl?.value);
		if (requestedAmount > balance) {
			this.globalSearchService.showNotification('Amount exceeds remaining balance', 'warning', 'bottom', 'right');
			return;
		}
		const chargeAmount = requestedAmount > 0 ? requestedAmount : this.financial(balance);

		this.terminalTransactionInProgress = true;
		const modalRef = this.modalService.open(TerminalTransactionModalComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modalRef.componentInstance.terminal = this.selectedTerminal;
		modalRef.componentInstance.amount = chargeAmount;
		modalRef.componentInstance.orderData = {
			debtorno: this.debtorno,
			branchcode: this.branchcode,
			orderno: this.orderno
		};
		modalRef.componentInstance.invoice = this.orderno != null ? String(this.orderno) : undefined;
		const userVal = this.globalSearchService.user.getValue();
		const user = userVal?.user || userVal;
		const empcode = this.globalSearchService.empCode?.getValue?.();
		modalRef.componentInstance.clerkId = (empcode != null && empcode !== '') ? String(empcode) : (user?.userid != null ? String(user.userid) : undefined);

		modalRef.result.then(
			(result) => {
				this.terminalTransactionInProgress = false;
				if (result.success) {
					if (result.ecr_print_success === false && result.ecr_print_error) {
						this.globalSearchService.showNotification(`ECR printing failed: ${result.ecr_print_error}`, 'warning', 'bottom', 'right');
					}
					this.addTerminalPayment(result);
				}
			},
			(dismissed) => {
				this.terminalTransactionInProgress = false;
				this.globalSearchService.showNotification('Terminal transaction cancelled', 'info', 'bottom', 'right');
			}
		);
	}

	addTerminalPayment(transactionResult: any) {
		const terminalAmount = transactionResult.amount || this.financial(this.getBalance());
		const terminalPaymentType = this.getTerminalPaymentTypeFromResult(transactionResult) || this.getTerminalPaymentType();
		if (!terminalPaymentType) {
			this.globalSearchService.showNotification('No valid payment method available for terminal payments', 'warning', 'bottom', 'right');
			return;
		}
		const remainingAfterPayment = this.financial(this.getBalance()) - this.financial(terminalAmount);
		const shouldAutoComplete = remainingAfterPayment <= 0;

		const data = {
			payment: {
				...this.paymentForm.value,
				type: terminalPaymentType,
				amount: terminalAmount,
				terminal_transaction_id: transactionResult.terminal_transaction_id,
				terminal_id: transactionResult.terminal_id,
				terminal_status: transactionResult.status,
				transaction_type: transactionResult.transaction_type,
				auth_code: transactionResult.auth_code,
				card_last_four: transactionResult.card_last_four,
				card_type: transactionResult.card_type,
				card_type_code: transactionResult.card_type_code,
				entry_method: transactionResult.entry_method,
				entry_mode_code: transactionResult.entry_mode_code,
				response_code: transactionResult.response_code,
				response_text: transactionResult.response_text,
				transaction_sequence: transactionResult.transaction_sequence,
				invoice: transactionResult.invoice,
				reference: transactionResult.reference,
				emv_aid: transactionResult.emv_aid,
				emv_app_label: transactionResult.emv_app_label,
				tip_amount: transactionResult.tip_amount,
				total_amount: transactionResult.total_amount,
				amount_due: transactionResult.amount_due,
				receipt_data: transactionResult.receipt_data,
				client_sent_at: transactionResult.client_sent_at,
				node_received_at: transactionResult.node_received_at,
				print_connect_received_at: transactionResult.print_connect_received_at,
				print_connect_responded_at: transactionResult.print_connect_responded_at,
				node_broadcast_at: transactionResult.node_broadcast_at,
				terminal_response: transactionResult
			},
			order: {
				orderno: this.orderno || '1',
				debtorno: this.debtorno,
				branchcode: this.branchcode,
				document_type: this.document_type
			}
		};

		this.paymentsService.addPayment(data).subscribe(
			(results: any[]) => {
				if (results['message'] && results['message'] != '') {
					this.globalSearchService.showNotification(results['message'], 'warning', 'bottom', 'right');
				}
				this.payments_added.emit({ autoCompleteTerminal: shouldAutoComplete });
				this.resetPayForm();
			},
			(error) => {
				this.globalSearchService.showNotification('Failed to record payment', 'danger', 'bottom', 'right');
			}
		);
	}

	removePayment(payment_id: any) {
		//this.payments[index].splice(0,1);
		this.paymentsService.removePayment(payment_id).subscribe((results: any[]) => {
			//this.getPayments();
			this.payments_removed.emit(false);
		});

	}

	updatePaymentAmount(event: any, payment: any) {
		payment.amount = event.target.value;
		this.updatePayment(payment)
	}

	updatePaymentType(event: any) {

		const thispay = this.paymentmethods.filter(p => {
			return p.paymentname === event.value
		})[0];

		if (thispay) {
			if (thispay.cc_process != '0') {
				this.card_required = true;
			} else {
				this.card_required = false;
				this.paymentForm.get('card_selected').setValue(false);
			}
		}
	}

	getBalance() {
		const total = this.totals && Array.isArray(this.totals)
			? this.totals.filter(t => t.code === 'total')[0]
			: null;

		let total_amount = 0.00;

		if (total && this.totals.length) {
			total_amount = total.text
		}

		const value = this.financial(total_amount) - this.financial(this.getTotalPayment());
		if (value < 0) {
			this.payments.forEach((pay) => {
				//Is there cash involved, then we can give change.
				//&& pay.value > 0 &&
				if (this.openCashDroor(pay.payment_type_id) && value < 0) {
					this.change_due = value;
					//It's cash!
					// if (pay.value > Math.abs(value)) {
					// 	this.change_due = Math.abs(value);
					// 	value = 0;
					// } else {
					// 	this.change_due = pay.value;
					// 	value = value + pay.value;
					// }
				} else {

				}
			});
		} else {
			this.change_due = 0;
		}

		return value;
	}

	updatePaymentReference(event: any, payment: any) {
		payment.reference = event.target.value;
		this.updatePayment(payment)
	}

	updatePaymentBank(event: any, payment: any) {
		payment.bankaccount = event.target.value;
		this.updatePayment(payment)
	}

	updatePayment(payment: any) {
		//this.payments[index].splice(0,1);
		this.paymentsService.updatePayment(payment).subscribe((results: any[]) => { this.payments = results });
		this.getPayments();
	}

	resetPayForm() {
		this.useOtherPaymentMethod = false;
		const account = (this.bankaccounts && this.bankaccounts[0]) ? this.bankaccounts[0].accountcode : '';

		this.paymentForm = this.formBuilder.group({
			reference: [''],
			amount: [this.balance_due, [Validators.required]],
			type: [this.default_payment, [Validators.required]],
			bankaccount: [account, [Validators.required]],
			card_selected: [false],
			charge_card: [false],
		});

		this.setBalanceValue();
	}

	private getTerminalPaymentTypeFromResult(transactionResult: any): string | null {
		const cardType = transactionResult?.card_type?.trim();
		if (!cardType || !this.paymentmethods?.length) {
			return null;
		}
		const lower = cardType.toLowerCase();
		const match = this.paymentmethods.find((method: any) =>
			(method.paymentname || '').toLowerCase() === lower
		);
		return match?.paymentname || null;
	}

	private getTerminalPaymentType(): string | null {
		if (!this.paymentmethods || !this.paymentmethods.length) {
			return null;
		}
		const cardMethod = this.paymentmethods.find((method: any) => method.cc_process != '0');
		return cardMethod?.paymentname || this.paymentmethods[0]?.paymentname || null;
	}

	getPayments() {

		this.payments_added.emit(false);
	}

	balance(): number {
		
		let balance = 0.00;
		if (this.payments && this.payments.length > 0) {

			const payment_total = this.payments.reduce(function(accumulator, am) {
				return accumulator + parseFloat(am.amount);;
			}, 0);

			balance = this.financial(this.totals.total) - this.financial(payment_total);
		}

		this.balance_due = this.financial(balance)
		return this.financial(balance);
	}

	getTotalPayment() {
		let total = 0.00
		if (this.payments && this.payments.length > 0) {
			total = this.payments.reduce(function(accumulator, am) {
				return accumulator + parseFloat(am.amount);;
			}, 0);
		}

		total = this.financial(total + this.creditAmt);
		return total;
	}


	changeCard(event: any) {
		if (event && event.card_type) {
			this.paymentForm.get('type').setValue(event.card_type);
		}
	}

	lastFour(value: any) {
		return 'XX' + value.substr(value.length - 4);
	}

	formatCardOptionLabel(method: any): string {
		if (!method) {
			return '';
		}
		const raw = String(method.display_number ?? method.number ?? '').trim();
		if (!raw) {
			return '';
		}
		if (/^TOKEN/i.test(raw)) {
			const lf = String(method.last_four ?? '').replace(/\D/g, '');
			if (lf.length >= 4) {
				return 'XXXXXXXXXXXX' + lf.slice(-4);
			}
			const tail = raw.replace(/\D/g, '').slice(-4);
			if (tail.length === 4) {
				return 'XXXXXXXXXXXX' + tail;
			}
			return 'Card on file';
		}
		return raw;
	}

	ngOnChanges(changes: any) {
		if (changes.debtorno) {
			this.getPayments();
			this.loadProfile(this.debtorno, this.branchcode);

			if (changes.order_header?.currentValue?.preselectedpay) {
				this.preselected_payment = changes.order_header.currentValue.preselectedpay;
			}
		}

		if (changes.order_header) {
			// Handle order header changes if needed
		}

		// Remove duplicate payment change handler - consolidate into one
		if (changes.payments) {
			if (changes.payments.currentValue && changes.payments.currentValue.length) {
				// When payments change, update balance (setBalanceValue handles untouched/default checks)
				if (this.paymentForm) {
					this.setBalanceValue();
				}
			}
		}

		if (this.paymentForm) {
			if (this.paymentForm.untouched) {
				if (this.bankaccounts) {
					this.paymentForm.get('bankaccount').setValue(this.bankaccounts[0].accountcode)
				}
			}

			if (!this.profile_cards && this.preselected_payment && this.paymentForm) {
				this.loadingcards = true;
				this.paymentsService.loadProfile(this.debtorno, this.branchcode).subscribe(async (result: any) => {
					this.loadingcards = false;
					if (result.cards) {
						this.hasprofile = true;
						this.profile_cards = result.cards
						this.paymentForm.get('type').setValue(this.preselected_payment.card_type);

						const card = this.profile_cards.filter((c: any) => {
							return c.card_id === this.preselected_payment.card_id;
						})[0];

						this.paymentForm.get('card_selected').setValue(card);
						const paymentid = this.getPaymentIdFromName(this.preselected_payment.card_type);
						this.setCardRequired(paymentid)
					} else {
						this.hasprofile = false;
						this.profile_cards = [];
						this.payment_card = false;
					}
				});
			}

			// Only update balance if form is untouched
			if (this.payments && this.paymentForm.untouched) {
				this.setBalanceValue();
			}

			this.balance();
		}

		if(changes.debtorno){
			this.getPayments();
		}

		if(changes.credits){
			let amt = 0;
			if(changes.credits.currentValue.length && changes.credits.currentValue[0]){
				this.appliedCredits = changes.credits.currentValue;
				(this.appliedCredits).forEach(cr => {
					amt += cr.applied;
				});
				this.creditAmt = amt;
			}else{
				this.creditAmt = 0;
				this.appliedCredits = [];
			}
			// Only update amount if form is untouched
			if (this.paymentForm && this.paymentForm.untouched) {
				this.setBalanceValue();
			}
		}
	}

	setBalanceValue(): void {
		const balance = this.getBalance();
		const amountControl = this.paymentForm?.get('amount');

		if (!amountControl) {return;}

		const currentValue = parseFloat(amountControl.value) || 0;
		const isDefaultValue = currentValue === 0 || currentValue === balance;
		const isUntouched = this.paymentForm.untouched;
		const isAmountDirty = amountControl.dirty || amountControl.touched;

		// If form is untouched (reset state) AND amount field hasn't been manually edited, update to current balance
		// Otherwise, only auto-set if field is in default state (preserves user input)
		// Never override user's manual input - allow amount to be changed before payment type selection
		if ((isUntouched && !isAmountDirty) || (isDefaultValue && !isAmountDirty)) {
			if (balance >= 0) {
				amountControl.setValue(this.financial(balance));
			} else {
				amountControl.setValue(0.00);
			}
		}
		// Otherwise, preserve user's manual input
	}

	getPaymentIdFromName(name: any) {
		if (this.paymentmethods) {
			const type = this.paymentmethods.filter(p => {
				return p.paymentname === name
			})[0];

			if (type) {
				return type.paymentid;
			}
		}
		return false;

	}

	loadProfile(debtorno: any, branchcode: any) {
		this.loadingcards = true;
		this.paymentsService.loadProfile(debtorno, branchcode).subscribe(async (result: any) => {
			this.loadingcards = false;
			if (result.cards) {
				this.hasprofile = true;
				this.profile_cards = result.cards
				const card = result.cards.filter((c: any) => {
					return c.default
				})[0];
				this.paymentForm.get('card_selected').setValue(card);

			} else {
				this.hasprofile = false;
				this.profile_cards = [];
				this.payment_card = false;
				this.paymentForm.get('card_selected').setValue(false);
			}
		});
	}

	addOnRequired() {

		let value = false;
		if (this.paymentmethods) {
			const thispay = this.paymentmethods.filter(p => {
				return p.paymentname == this.paymentForm.get('type').value
			})[0];
			if (thispay) {
				if (thispay.additionalrequired == '1') {
					value = true;
				}
			}
		}

		return value;
	}
	openCashDroor(method: any) {

		let value = false;
		if (this.paymentmethods) {
			const thispay = this.paymentmethods.filter(p => {
				return p.paymentid == method
			})[0];
			if (thispay) {
				if (thispay.opencashdrawer == '1') {
					value = true;
				}
			}
		}

		return value;
	}

	setCardRequired(method: any) {

		if (method) {
			const thispay = this.paymentmethods.filter(p => {
				return p.paymentid == method
			})[0];

			if (thispay) {

				if (thispay.cc_process !== '0') {
					this.card_required = true;
				} else {
					this.card_required = false;
					this.paymentForm.get('charge_card').setValue(false);
					this.paymentForm.get('card_selected').setValue(false);
				}
			}
		}
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}


	runKey(value: any) {
		const amountControl = this.paymentForm.get('amount');

		switch (value) {
		case 'add':
			this.addPayment();
			break;
		case 'backspace':
			const newvalue = (this.paymentForm.get('amount').value + '').slice(0, -1);
			if (newvalue != '') {
				this.paymentForm.get('amount').setValue(newvalue);
			} else {
				this.paymentForm.get('amount').setValue(0.00);
			}
			amountControl.markAsTouched();
			break;
		case 'minus':
			this.makeNegativePayment()
			amountControl.markAsTouched();
			break;
		case '0':
		case '.':
			var periodval = this.paymentForm.get('amount').value + '' + value;
			this.paymentForm.get('amount').setValue(periodval);
			amountControl.markAsTouched();
			break;
		default:
			const currentvalue = this.paymentForm.get('amount').value + '' + value;
			this.paymentForm.get('amount').setValue(this.financial(currentvalue));
			amountControl.markAsTouched();
			break;
		}
	}

	setChargeType(event: MatButtonToggleChange) {
		const selectedPaymentName = event.value;
		const method = this.getPaymentMethodByName(selectedPaymentName);

		if (selectedPaymentName) {
			const paymentFormControl = this.paymentForm.get('type');
			if (paymentFormControl) {
				paymentFormControl.setValue(selectedPaymentName);
			}

			this.updatePaymentType(selectedPaymentName);
			this.setCardRequired(method.paymentid);

			setTimeout(() => {
				this.amountIdRef.nativeElement.focus();
				if (method?.opencashdrawer !== '1') {
					const currentAmount = parseFloat(this.paymentForm.get('amount').value) || 0;
					const balance = this.getBalance();
					const amountControl = this.paymentForm.get('amount');
					const isAmountDirty = amountControl.dirty || amountControl.touched;

					// Only auto-set if amount is 0 or matches balance AND user hasn't manually edited it
					// This allows users to change amount first, then select payment type for split payments
					if (!isAmountDirty && (currentAmount === 0 || currentAmount === balance)) {
						this.setBalanceValue();
					}
				}
			}, 0);
		}
	}

	getPaymentMethodByName(paymentname: string) {
		return this.paymentmethods.find(method => method.paymentname === paymentname);
	}

	ngAfterViewInit(): void {


	}

	removeCredit(credit){
		this.credit_removed.emit(credit);
	}

}
